import { render } from "./ProsesInbox.vue?vue&type=template&id=69ce03be"
import script from "./ProsesInbox.vue?vue&type=script&lang=js"
export * from "./ProsesInbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__